import React from "react";
import { Check } from "@phosphor-icons/react";
import { useNotificationModal } from "../../../context/NotificationContext";
const InAppNotificationModal = () => {
  const { isVisible, modalProps, hideNotificationModal } =
    useNotificationModal();

  if (!isVisible || !modalProps) {
    return null;
  }

  const {
    primaryAction,
    secondaryAction,
    primaryButtonLabel,
    secondaryButtonLabel,
    title,
    image,
    content,
  } = modalProps;

  return (
    <div className="bg-surface_overlay backdrop-blur-2xl text-body fixed grid items-center  top-0 left-0 w-full h-screen overflow-auto  z-40">
      <div
        className={`grid ${
          image ? "grid-cols-2 max-w-5xl" : "max-w-xl"
        }  gap-5 md:gap-8 mx-4   md:mx-auto bg-white md:w-1/2 border md:min-h-[70vh] border-border_lighter p-5 md:p-8 rounded-xl`}
      >
        {title && image && (
          <div className="bg-surface_default hidden md:block space-y-8 h-full pt-12 px-6 rounded-lg ">
            <h2 className="text-center text-body_base font-bold text-subtle">
              {title}
            </h2>
            {image}
          </div>
        )}
        <div className={`flex  md:flex-row relative `}>
          <div className="flex-grow space-y-7 ">
            <div
              className={`flex  flex-col  space-y-7 justify-between items-center`}
            >
              <div className="grid place-items-center gap-y-7">
                <div className="h-18 w-18 bg-green_700 grid place-items-center rounded-full">
                  <Check color="white" size={40} />
                </div>
                <h2 className="text-heading_sm font-bold text-center">
                  Action Completed Successfully
                </h2>
              </div>

              <div className="bg-green_50 border text-center text-body_sm font-bold text-green_700 border-green_700 p-5 rounded-lg ">
                You have succesfully completed this action. Enjoy a seamless
                experience on the network that cares for you. <br /> Telecel,
                Connecting Energies
              </div>
            </div>
            <div className="">{content}</div>
            <div className="grid md:grid-cols-2  md:absolute bottom-0 w-full  items-center gap-2">
              {!!primaryButtonLabel && (
                <button
                  className={`w-full  tracking-wider bg-brand border border-red_600 text-negative text-subtitle rounded-full py-4 hover:bg-red_600 cursor-pointer`}
                  aria-label={primaryButtonLabel}
                  type="button"
                  onClick={() => {
                    primaryAction?.();
                    hideNotificationModal();
                  }}
                >
                  <div className={`  text-center w-full cursor-pointer`}>
                    <div className="flex justify-center">
                      {primaryButtonLabel}
                    </div>
                  </div>
                </button>
              )}
              {!!secondaryButtonLabel && (
                <div className=" w-full ">
                  <button
                    aria-label={secondaryButtonLabel}
                    type="button"
                    onClick={() => {
                      secondaryAction?.();
                      hideNotificationModal();
                    }}
                    className={` text-center w-full border border-brand px-4 cursor-pointer bg-border_lightest rounded-full py-4 text-subtitle`}
                  >
                    {secondaryButtonLabel}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InAppNotificationModal;
